import IndividualControlIcon from './component'

export default IndividualControlIcon
